import React from 'react';
import { useIntl } from 'react-intl';
import { isNumber, noop } from 'lodash';
import { Layer, Loading, Pane, PaneFooter, Paneset } from '@folio/stripes/components';
import { Buttons } from '../Buttons';
import { t } from '../../services';
import { ListAppIcon } from '../ListAppIcon';
export var EditListLayout = function (_a) {
    var children = _a.children, name = _a.name, title = _a.title, isLoading = _a.isLoading, recordsCount = _a.recordsCount, _b = _a.onCancel, onCancel = _b === void 0 ? noop : _b, isSaveButtonDisabled = _a.isSaveButtonDisabled, _c = _a.onSave, onSave = _c === void 0 ? noop : _c, lastMenu = _a.lastMenu;
    var formatNumber = useIntl().formatNumber;
    var getRecordCountString = function (count) {
        if (isNumber(count)) {
            return t('mainPane.subTitle', { count: formatNumber(count) });
        }
        return '';
    };
    var paneSub = !isLoading ? getRecordCountString(recordsCount)
        : React.createElement(React.Fragment, null,
            t('lists.item.loading'),
            React.createElement(Loading, null));
    if (isLoading) {
        return React.createElement(Loading, null);
    }
    // @ts-ignore
    return (React.createElement(Paneset, null,
        React.createElement(Layer, { isOpen: true, contentLabel: name },
            React.createElement(Paneset, { isRoot: true },
                React.createElement(Pane, { dismissible: true, defaultWidth: "fill", appIcon: React.createElement(ListAppIcon, null), paneTitle: title, paneSub: paneSub, onClose: onCancel, lastMenu: lastMenu, footer: React.createElement(PaneFooter, { renderStart: React.createElement(Buttons.Cancel, { onCancel: onCancel }), renderEnd: React.createElement(Buttons.Save, { disabled: !!isSaveButtonDisabled, onSave: onSave }) }) }, children)))));
};
